import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export const SnapTradeCallback: React.FC = () => {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
    const [message, setMessage] = useState('Processing connection...');

    useEffect(() => {
        // console.log('Current URL:', window.location.href);
        
        // With BrowserRouter, useSearchParams works correctly
        const urlStatus = searchParams.get('status');
        const connectionId = searchParams.get('connection_id');
        
        // console.log('Status:', urlStatus);
        // console.log('Connection ID:', connectionId);

        if (urlStatus === 'SUCCESS') {
            setStatus('success');
            setMessage('Brokerage connected successfully!');
            
            // Notify opener window of success
            if (window.opener && !window.opener.closed) {
                window.opener.postMessage({ 
                    type: 'SNAPTRADE_CONNECTION_SUCCESS',
                    connection_id: connectionId
                }, '*');
            }
        } else if (urlStatus === 'ERROR' || urlStatus === 'FAILURE') {
            setStatus('error');
            setMessage('Connection failed. Please try again.');
            
            // Notify opener window of error
            if (window.opener && !window.opener.closed) {
                window.opener.postMessage({ 
                    type: 'SNAPTRADE_CONNECTION_ERROR',
                    error: 'Connection failed'
                }, '*');
            }
        } else {
            // Unknown status
            setStatus('error');
            setMessage('Invalid connection status. Please try again.');
            
            if (window.opener && !window.opener.closed) {
                window.opener.postMessage({ 
                    type: 'SNAPTRADE_CONNECTION_ERROR',
                    error: 'Unknown status'
                }, '*');
            }
        }
    }, [searchParams]);

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
        }}>
            <div style={{
                backgroundColor: '#2a2a2a',
                padding: '40px',
                borderRadius: '10px',
                textAlign: 'center',
                maxWidth: '500px',
                width: '90%',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)'
            }}>
                {status === 'loading' && (
                    <>
                        <div style={{
                            width: '60px',
                            height: '60px',
                            border: '4px solid #444',
                            borderTop: '4px solid #4CAF50',
                            borderRadius: '50%',
                            animation: 'spin 1s linear infinite',
                            margin: '0 auto 20px'
                        }} />
                        <h1 style={{ color: '#fff', marginBottom: '10px' }}>Verifying Connection...</h1>
                        <p style={{ color: '#aaa' }}>{message}</p>
                    </>
                )}

                {status === 'success' && (
                    <>
                        <div style={{
                            width: '80px',
                            height: '80px',
                            backgroundColor: '#4CAF50',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto 20px',
                            fontSize: '48px',
                            color: '#fff'
                        }}>
                            ✓
                        </div>
                        <h1 style={{ color: '#4CAF50', marginBottom: '10px' }}>Connection Successful!</h1>
                        <p style={{ color: '#aaa', marginBottom: '20px' }}>{message}</p>
                        <p style={{ color: '#888', fontSize: '14px', marginBottom: '20px' }}>
                            You may now close this window.
                        </p>
                        <button
                            onClick={() => window.close()}
                            style={{
                                padding: '10px 20px',
                                backgroundColor: '#4CAF50',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                fontSize: '16px'
                            }}
                        >
                            Close Window
                        </button>
                    </>
                )}

                {status === 'error' && (
                    <>
                        <div style={{
                            width: '80px',
                            height: '80px',
                            backgroundColor: '#f44336',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto 20px',
                            fontSize: '48px',
                            color: '#fff'
                        }}>
                            ✗
                        </div>
                        <h1 style={{ color: '#f44336', marginBottom: '10px' }}>Connection Failed</h1>
                        <p style={{ color: '#aaa', marginBottom: '20px' }}>{message}</p>
                        <button
                            onClick={() => window.close()}
                            style={{
                                padding: '10px 20px',
                                backgroundColor: '#444',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                fontSize: '16px'
                            }}
                        >
                            Close Window
                        </button>
                    </>
                )}

                <style>{`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}</style>
            </div>
        </div>
    );
};
